@import '../../styles/palette';
@import '../../styles/fonts';

.searchFieldWrapper {
  .searchAndLimit {
    display: flex;
    align-items: flex-end;

    .searchField {
      flex: 3;
    }

    .limitField {
      flex: 1;
      margin: 0 0.5em;
    }

    .searchBtn {
      flex: 1;
      margin-bottom: 0.075em;
    }
  }

  .gjeldendeOnlyCheckbox {
    margin: 0.5em 0 1em 0;
    width: fit-content;
  }
}

$border: 0.1em solid _palette(table-row-border);

.choosePraksisstedList {
  li {
    border-top: $border;
    border-bottom: $border;
    padding: 0.33em 0;

    &:hover,
    &:hover:focus {
      cursor: pointer;
    }

    &:hover:not(.currentPraksissted),
    &:focus:not(.currentPraksissted),
    &:hover:focus:not(.currentPraksissted) {
      background-color: _palette(table-row-shade);
    }

    &.currentPraksissted {
      background-color: _palette(table-row-sky);
    }
  }
}

.treeContainer {
  height: 40em;
  width: 100%;
  border: 0.1em solid _palette(table-row-border);
  border-radius: 0.5%;
}

.circle {
  stroke: _palette(text);

  &.mainCircle {
    stroke-width: 0.33em;
    stroke: _palette(warning-icon);
  }

  &.relevantCircle {
    fill: red;
  }

  &.irrelevantCircle {
    fill: green;
  }

  &.overnodeCircle {
    fill: _palette(secondary);
  }
}

.name {
  @include barlow(14);
}

.descriptionIcons {
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0;

  .descriptionIcon {
    display: flex;
    align-items: center;

    svg {
      height: 40px;
      width: 40px;
    }

    p {
      margin-right: 0.5em;
    }
  }
}

.praksisstedInfoModal {
  min-width: 75%;
  max-width: 90%;

  .subSection {
    margin-bottom: 0.5em;

    .header {
      @include barlow(16, 700);
    }

    .subSectionContent {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .propertyEntry {
    margin: 0.5em 0.5em 0.5em 0 !important;
    width: 27em;

    .boldRegularPair {
      display: block;

      &.large {
        .bold {
          @include barlow(16, 600);
        }

        .regular {
          @include barlow(16);
        }
      }

      &:not(.large) {
        .bold {
          @include barlow(14, 600);
        }

        .regular {
          @include barlow(14);
        }
      }

      .bold {
        margin-right: 0.33em;
      }
    }
  }
}

.praksisstedsokHelp {
  h3 {
    @include barlow(16, 500);
    margin-top: 0.3em;
  }

  p {
    max-width: 40em;
  }
}
